import type { Dispatch, Action } from 'redux';
import { setIntroOpen } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/onboarding';
import { deletePlan } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/plan';
import {
	setDeleteDialogVisibility,
	redirectToSettings as redirectToSettingsAction,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/top/title-bar/plan-settings/actions';
import { toggleToolBar } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/top/title-bar/tool-bar/actions';
import { redirectToSettings } from '@atlassian/jira-portfolio-3-portfolio/src/common/window';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (dispatch: Dispatch<Action>) => ({
	toggleOpenDeleteDialog: (visibility: boolean) => dispatch(setDeleteDialogVisibility(visibility)),
	redirectToSettings: (redirectFrom: string) => {
		dispatch(redirectToSettingsAction(redirectFrom));
		redirectToSettings();
	},
	showOnboarding: () => {
		dispatch(setIntroOpen(true));
	},
	onDeletePlan: () => dispatch(deletePlan()),
	toggleToolBar: () => {
		dispatch(toggleToolBar());
	},
});
